/**
 * File: index.js
 * Origin: isotect
 * Description: [TODO: Description]
 *
 * Version: v1.1.0
 * Created: 2025-07-23
 * Last Updated: 2026-06-23
 *
 * Used By: isotect
 * Maintainer: Zachary Dicks
 *
 * Notes:
 * - Changes in this file may affect all consuming frontend modules.
 * - See Git repository 'isotect' for full change history.
 */

// Third-party packages
import React from "react";
import ReactDOM from "react-dom/client";

// Local project files
import App from "./App";

// Constants
const container = document.getElementById("root");
const appTree = (
    <React.StrictMode>
        <App />
    </React.StrictMode>
);

// Generate Application
if (container.hasChildNodes()) {
    ReactDOM.hydrateRoot(container, appTree);
} else {
    ReactDOM.createRoot(container).render(appTree);
}

//reportWebVitals(console.log);
